export enum HowItWorksModalActions {
  OPEN_HOW_IT_WORKS_MODAL = "OPEN_HOW_IT_WORKS_MODAL",
  CLOSE_HOW_IT_WORKS_MODAL = "CLOSE_HOW_IT_WORKS_MODAL"
}

export interface IOpenHowItWorksModalAction {
  type: HowItWorksModalActions.OPEN_HOW_IT_WORKS_MODAL;
}

export interface ICloseHowItWorksModalAction {
  type: HowItWorksModalActions.CLOSE_HOW_IT_WORKS_MODAL;
}

export const openHowItWorksModal = () => {
  return {
    type: HowItWorksModalActions.OPEN_HOW_IT_WORKS_MODAL
  };
};

export const closeHowItWorksModal = () => {
  return {
    type: HowItWorksModalActions.CLOSE_HOW_IT_WORKS_MODAL
  };
};

export type HowItWorksActions =
  | IOpenHowItWorksModalAction
  | ICloseHowItWorksModalAction;
